<template>
  <div id="Declare">

    <Head />
    <div class="declare">
      <div class="leftNav">
        <decLeftNav ref="LeftNav" />
      </div>
      <!-- 申报说明的图片 -->
      <div class="black">
        <div class="title">申报说明</div>
        <div class="time">更新时间：{{ noticeInfo.update_time }}</div>
        <div class="t_main">
          <div v-html="noticeInfo.content" style="margin-top: 20px;"></div>
        </div>
        <div v-if="t == 1" :class="{ btn: true, none: s != 0 }" @click="createTable">
          {{ btnText }}{{ s != 0 ? '(' + s + ")" : "" }}
        </div>
        <div v-else-if="t == 10" class="btn none">{{ btnText }}</div>
      </div>
    </div>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
import decLeftNav from "../../components/decLeftNav";
import RightNav from "../../components/RightNav";
import Vue from "vue";
export default {
  name: "Declare",
  data() {
    return {
      s: 0,
      btnText: "请先登录",
      isTable: false,
      t: 1,
      control: "",
      token: sessionStorage.getItem("token"),
      noticeInfo: {},
      isabled: false,
    };
  },
  created() {
    window.scrollTo(0, sessionStorage.getItem("scroll"));
    if (this.token) this.$store.dispatch("getStatus");
    this.getinfo()
  },
  mounted() {
    this.t = sessionStorage.getItem("t");

    this.control = this.$store.state.value1;

    if (this.token) this.isTables();
  },
  computed: {
    switch() {
      return this.$store.state.value1;
    },
  },
  watch: {
    switch: function (val) {
      this.control = val;
    },
  },
  methods: {
    getinfo() {
      var that = this;
      that.$axios
        .post(
          "notice/ruleinfo?token=" + sessionStorage.getItem("token"),
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            this.noticeInfo = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    //判断是否有已提交的申报表
    isTables() {
      let that = this;
      that.$axios
        .post(
          "report/myreport?token=" +
          sessionStorage.getItem("token")
        )
        .then(function (res) {
          if (res.data.code == 10000) {
            if (res.data.zt == 0) {
              // console.log("进入1判断" + res.data.msg);
              that.s = 10;
              that.btnText = "立即申报";
              sessionStorage.setItem("isTable", false);
              let loop = setInterval(function () {
                that.s--;
                if (that.s == 0) {
                  clearInterval(loop);
                }
              }, 1000);
            } else {
              console.log(res.data.zt);
              if (res.data.zt == 1) {
                that.btnText = "继续填写";
                console.log(res.data.data);
                sessionStorage.setItem("isTable", true);
                sessionStorage.setItem("ReportID", res.data.data.reportID);
              } else if (res.data.zt == 2) {
                that.btnText = "查重中";
                sessionStorage.setItem("isTable", false);
              } else if (res.data.zt == 3) {
                that.btnText = "报告生成中";
                sessionStorage.setItem("isTable", false);
              } else if (res.data.zt == 4) {
                that.btnText = res.data.msg;
                that.t = 10
                sessionStorage.setItem("isTable", false);
              }
            }
          } else if (res.data.code == 10002) {
            that.$message({
              type: "warning",
              message: res.data.msg,
            });
          }

          that.$refs.LeftNav.isTable();
        })
        .catch(function () { });
    },
    //新建申报表
    createTable() {
      let that = this;
      if (this.s != 0) {
        return;
      }
      if (!sessionStorage.getItem("token")) {
        this.$message({
          showClose: true,
          message: "请在登录后进行操作",
          type: "warning",
        });
      } else {
        if (sessionStorage.getItem("isTable") == "true") {
          that.$router.replace("/Surface");
        } else {
          that.$axios
            .post(
              "report/save?token=" + sessionStorage.getItem("token"),
              that.$qs.stringify({
                DeclarTime: new Date(),
                Province: "",
                MouldID: "MD1",
              })
            )
            .then(function (res) {
              if (res.data.code == 10000) {
                Vue.prototype.$isTable = true;
                that.$router.push("/Surface");

                sessionStorage.setItem("ReportID", res.data.ID);
                sessionStorage.setItem("isTable", true);
                sessionStorage.setItem("isListGo", false);
              } else if (res.data.code == 10002) {
                this.$message({
                  type: "warning",
                  message: res.data.msg,
                });
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function () { });
        }
      }
    },
  },
  components: {
    Head,
    Foot,
    decLeftNav,
    RightNav,
  },
};
</script>
<style lang="less" scope>
#Declare {
  width: 100%;
  min-width: 1000px;

  .declare {
    width: 100%;
    padding: 0 1.35rem;
    margin-top: 0.4rem;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .leftNav {
      padding-right: 0.4rem;
      border-right: 0.01rem solid #e4e4e4;
    }

    .black {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 12.5rem;
      position: relative;

      .title {
        text-align: center;
        font-size: 0.5rem;
        // font-weight: bold;
      }

      .time {
        text-align: center;
        color: #6d6d6d;
      }

      .t_main {
        // border: #6d6d6d .02rem solid;
      }

      border-radius: .2rem;
      // background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
      // background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%);
      background-image: linear-gradient(to top, #c1dfc4 0%, #deecdd 100%);
      padding: .1rem;

      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      >img {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        height: 8.5rem;
      }

      .bA {
        display: flex;
        justify-content: center;
        position: relative;
        font-size: 0.5rem;
        z-index: 1000;

        img {
          width: 8rem;
          position: relative;
          height: 1.5rem;
          opacity: 0;
        }

        span {
          position: absolute;
          margin-top: 0.3rem;
        }
      }

      .bB {
        display: flex;
        justify-content: center;
        position: relative;
        top: -1rem;

        >img {
          width: 12rem;
          position: relative;
          height: 7.5rem;
        }

        div {
          width: 11rem;
          position: absolute;
          font-size: 0.25rem;

          span {
            display: block;
            text-align: center;
            font-size: 0.5rem;
            margin-top: 1.5rem;
            color: #ffffff;
          }

          // .imgA {
          //   width: 1.7rem;
          //   margin-bottom: 0.2rem;
          //   float: right;
          //   position: relative;
          //   top: -0.6rem;
          // }
          .imgB {
            width: 100%;
            height: 100%;
            position: relative;
            top: 1.8rem;
          }

          ul {
            width: 100%;

            li {
              margin-bottom: 0.4rem;
              color: #fff;
            }
          }
        }
      }

      .btnds {
        border: 0.01rem solid #9c9c9c !important;
        color: #9c9c9c !important;
      }

      .btn {
        font-size: 0.25rem;
        width: 3rem;
        height: 0.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.05rem;
        margin: 0 auto;
        margin-top: 0.3rem;
        border: 0.01rem solid #3f6bc2;
        color: #3f6bc2;
        cursor: pointer;

        &.none {
          border-color: #6d6d6d;
          color: #7d7c7c;
        }
      }
    }
  }
}
</style>